import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  ContainerProgressCard,
  ProgressBar,
  Header,
  Text,
} from './styles';

const ProgressCardComponent = (props) => {
  const {
    percentage,
    title,
    description,
  } = props;

  return (
    <Container>
      <Header as="h3">{title}</Header>

      <ContainerProgressCard>
        <ProgressBar
          value={percentage}
          text={`${percentage}%`}
        />
      </ContainerProgressCard>

      <Text>{description}</Text>
    </Container>
  );
};

ProgressCardComponent.propTypes = {
  percentage: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default ProgressCardComponent;
